import { Card } from '../ui/card';

export const LoadingSkeleton = () => {
  return (
    <div className="space-y-6">
      {/* Header Skeleton */}
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
        <div>
          <div className="w-20 h-4 rounded skeleton mb-2" />
          <div className="w-48 h-10 rounded skeleton mb-2" />
          <div className="w-64 h-4 rounded skeleton" />
        </div>
        <div className="flex gap-2">
          <div className="w-24 h-9 rounded-xl skeleton" />
          <div className="w-20 h-9 rounded-xl skeleton" />
        </div>
      </div>
      
      {/* Load Cards Skeleton */}
      <div className="space-y-4">
        {[1, 2, 3].map((i) => (
          <Card key={i} className="p-4 sm:p-6 rounded-2xl border-0 shadow-sm">
            <div className="flex flex-col sm:flex-row sm:items-start gap-4">
              <div className="w-12 h-12 rounded-xl skeleton" />
              <div className="flex-1 space-y-3">
                <div className="flex items-center gap-3">
                  <div className="w-40 h-5 rounded skeleton" />
                  <div className="w-24 h-5 rounded skeleton" />
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  <div className="w-full h-4 rounded skeleton" />
                  <div className="w-full h-4 rounded skeleton" />
                  <div className="w-full h-4 rounded skeleton" />
                  <div className="w-full h-4 rounded skeleton" />
                </div>
              </div>
              <div className="w-28 h-6 rounded skeleton" />
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};
